import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from './ListItem';

export const List = ({arrayItems, handleClickListItem, isIcon, classNameIcon}) => {

    return (
        <ul className="">

            {arrayItems.map(item => {
                return <ListItem key={item.id} 
                                 text={item.text} data={item} 
                                 handleClick={handleClickListItem} isIcon={isIcon}
                                 classNameIcon={classNameIcon}  /> 
             })
            } 
        </ul>
    );

};

List.propTypes = {
    arrayItems: PropTypes.array
};